import { useMemo } from 'react';

import { CLASSROOM_TYPE } from '@innovamat/radiance-utils';

import { useClassrooms } from '../../../../hooks/use-classrooms';
import type { Classroom } from '../../../../modules/classroom';
import { filterAndSortClassrooms } from '../../../../modules/classroom/classrooms';

type UseSchoolJourneysData = {
  journeys: Classroom[];
  hasUncheckedJourneys: boolean;
  isEmpty: boolean;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
};

// TODO use useClassroom hook instead of the classroomQuery
function useSchoolJourneysData(): UseSchoolJourneysData {
  const { classroomsQuery } = useClassrooms({
    mine: false,
  });

  const {
    data: classroomsData,
    isLoading: isClassroomsLoading,
    isSuccess: isClassroomsSuccess,
    isError: isClassroomsError,
  } = classroomsQuery;

  const classrooms = classroomsData?.classrooms as Classroom[];

  const journeys = useMemo((): Classroom[] => {
    if (!classrooms) return [];

    return filterAndSortClassrooms(classrooms, CLASSROOM_TYPE.JOURNEYS);
  }, [classrooms]);

  const isEmpty =
    !isClassroomsLoading && isClassroomsSuccess && journeys?.length === 0;

  const hasUncheckedJourneys = journeys?.some((journey) => {
    return !journey.checked || (journey.provider && !journey.providerChecked);
  });

  return {
    journeys,
    hasUncheckedJourneys,
    isEmpty,
    isError: isClassroomsError,
    isLoading: isClassroomsLoading,
    isSuccess: isClassroomsSuccess,
  };
}

export { useSchoolJourneysData };
